import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";

function Resume() {
  return (
    <Box id="resume" sx={{ py: 8, bgcolor: "background.paper" }}>
      <Container sx={{ textAlign: "center" }}>
        <Typography variant="h4" gutterBottom>Resume</Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Download or view my latest resume.
        </Typography>
        <Button
          variant="contained"
          href="/resume.pdf"
          download
          sx={{ bgcolor: "#52B2BF", color: "white", "&:hover": { bgcolor: "#42949E" } }}
        >
          Download Resume
        </Button>
        <Button
          variant="outlined"
          href="/resume.pdf"
          target="_blank"
          sx={{ ml: 2, borderColor: "#52B2BF", color: "#52B2BF",
                "&:hover": { borderColor: "#42949E", color: "#42949E" } }}
        >
          View Online
        </Button>
      </Container>
    </Box>
  );
}

export default Resume;
